import PreviewAsWidget from "designer/builder/ui/smart/preview-as-widget/preview-as-widget";
import { GlideFC } from "lib/glide-fc";
import * as React from "react";
import "twin.macro";
import { GlideIcon } from "../glide-icon/glide-icon";

interface Props {
    onBack?: () => void;
    url?: string;
}

export const BrowserContainer: GlideFC<React.PropsWithChildren<Props>> = p => {
    return (
        <div tw="rounded-lg pointer-events-auto absolute inset-2 shadow-2xl-dark bg-bg-back min-width[320px]">
            <div tw="rounded-lg overflow-hidden flex flex-col absolute inset-0">
                <div
                    tw="h-11 background-color[#E3E4E9] shadow-md-soft grid grid-cols-4 gap-2 items-center py-1 px-1
                         z-10">
                    <div tw="flex items-center">
                        <PreviewAsWidget />
                    </div>
                    <div tw="flex col-span-2 items-center">
                        <button
                            onClick={p.onBack}
                            tw="bg-bg-front text-n700A flex-shrink-0 h-7 w-7 inline-flex items-center justify-center
                                transition shadow-sm rounded-md overflow-hidden cursor-pointer hover:(shadow-lg
                                text-icon-dark)">
                            <GlideIcon kind="stroke" icon="st-caret" iconSize={20} rotateDeg={90} />
                        </button>
                        <div tw="flex-1 flex min-w-0 justify-center items-center ml-1">
                            <div tw="w-full h-7 flex items-stretch">
                                <a
                                    href={`https://localhost:3000/dl/${p.url}`}
                                    target="_blank"
                                    rel="noreferrer"
                                    tw="bg-bg-front rounded-md flex w-full flex-grow items-center text-n600A px-2
                                        space-x-2 shadow-sm transition hover:(text-text-base shadow-md)">
                                    <div tw="select-all overflow-ellipsis overflow-hidden whitespace-nowrap flex-1">
                                        https://localhost:3000/dl/{p.url}
                                    </div>
                                    <div tw="flex-shrink-0">
                                        <GlideIcon kind="stroke" icon="st-arrow-external" iconSize={16} />
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div></div>
                </div>
                <div tw="flex-grow relative">{p.children}</div>
            </div>
        </div>
    );
};
